﻿import React from 'react';
import {Grid} from "@mui/material";
import {styled} from "@mui/styles";

const Root = styled(Grid)(() => ({
  padding: '0.8em',
  border: '1px solid rgba(238, 238, 238, 1)',
  borderRadius: '0.5em',
  position: 'relative',
}));

type CardContainerProps = React.ComponentPropsWithoutRef<'div'>

/**
 * MUI Grid component styled in the SecurSpace way. Used as the main Container for creating a Card
 * @param children children passed through to the internal Grid component
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const CardContainer = ({ children, ...rest }: CardContainerProps) => {
  return <Root item {...rest}>
    { children }
  </Root>
}

export { CardContainer };
